import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import Query from '~/Api/Product/Query';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export default async function addProductsBySearch(
	client: ApiClient,
	userId: string,
	groupId: string,
	query: Query
): Promise<void> {
	const mappedFilters = query.filterParameters.reduce(
		(result: { [key: string]: string | string[] }, filterParameter) => {
			const parsedValue = filterParameter.parseDateValue();
			if (filterParameter.value === '') {
				return result;
			}
			if (filterParameter.name === 'country') {
				result.countries = filterParameter.value;
			} else if (filterParameter.name === 'datasource') {
				result.datasources = filterParameter.value;
			} else if (filterParameter.name === 'newerThan' && parsedValue) {
				result[filterParameter.name] = formatApiDate(parsedValue);
			} else {
				result[filterParameter.name] = filterParameter.value;
			}
			return result;
		},
		{}
	);

	const url = parseTemplate('users/{userId}/product-groups/{groupId}/add-products-by-search');

	try {
		await client.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body: JSON.stringify(mappedFilters),
		});
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new UserProductGroupErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
